<template>
  <v-app class="v1.0.4">
    <v-main>
      <router-view id="v1.0.4" />
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: 'App',
  data: () => ({
    //
  })
};
</script>
<style lang="scss">
@font-face {
  font-family: UhBee-mysen;
  src: local("UhBee mysen"),
  url('./assets/font/UhBee mysen.ttf');
  font-weight: normal;
}
@font-face {
  font-family: UhBee-mysen;
  src: local("UhBee mysen Bold"),
  url('./assets/font/UhBee mysen Bold.ttf');
  font-weight: bold;
}
@font-face {
    font-family: 'Fighting_hyonam';
    src: url('https://cdn.jsdelivr.net/gh/projectnoonnu/naverfont_04@1.0/Fighting_hyonam.woff') format('woff');
    font-weight: bold;
    font-style: normal;
}
@font-face {
    font-family: 'Hardworking';
    src: url('https://cdn.jsdelivr.net/gh/projectnoonnu/naverfont_06@1.0/Hardworking.woff') format('woff');
    font-weight: normal;
    font-style: normal;
}

#v-main {
  padding: 0;
  padding: calc(env(safe-area-inset-bottom)) 0 0 0 !important;
}

html, body, div, span, applet, object, iframe,
h1, h2, h3, h4, h5, h6, p, blockquote, pre,
a, abbr, acronym, address, big, cite, code,
del, dfn, em, img, ins, kbd, q, s, samp,
small, strike, strong, sub, sup, tt, var,
b, u, i, center,
dl, dt, dd, ol, ul, li,
fieldset, form, label, legend,
table, caption, tbody, tfoot, thead, tr, th, td,
article, aside, canvas, details, embed, 
figure, figcaption, footer, header, hgroup, 
menu, nav, output, ruby, section, summary,
time, mark, audio, video {
  margin: 0;
  padding: 0;
  border: 0;
  font-family: 'Pangolin', 'Roboto','Noto Sans KR','Dotum', 'Gulim', sans-serif;
  box-sizing: border-box;
}
ul, ol, li{
  list-style: none;
}
a{
  text-decoration: none;
}
.container{
  padding: 40px 20px !important;
  letter-spacing: -0.2px;
}
.customTitle{
  margin-bottom: 8px;
  color: #FFB5CC;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: -0.5px;

  &::after{
    content: '';
    width: 8px;
    margin-bottom: 16px;
    border-bottom: 2px solid #FFB5CC;
    display: block;
  }
}
.v-btn:not(.v-btn--round).v-size--default{
  border-radius: 40px;
  font-size: 14px;
  font-weight: 500;
  box-shadow: none;
}
.customButton{
  min-width: 80px !important;
  padding: 8px 20px !important;
  text-align: center;

  &.theme--light.v-btn.v-btn--has-bg{
    color: #fff;
    background-color: #FFB5CC;
  }
  &.gray{
    background-color: #b6b6b6 !important;
  }
}
.customButtonBox2{
  width: 100%;
  position: fixed;
  left: 0;
  bottom: 0;
  z-index: 1;
  display: flex;
  align-content: center;
  justify-content: space-between;

}
.customButton2{
  width: 100%;
  padding: 20px;
  color: #fff;
  font-size: 16px;
  font-weight: 500;
  font-family: 'Noto Sans KR';
  text-align: center;
  background-color: #FFB5CC;
  cursor: pointer;

  &.gray{
    background-color: #b6b6b6;
  }
}
.alert{
  width: 100%;
  padding: 8px;
  position: fixed;
  left: 0;
  bottom: 64px;
  z-index: 1000000;
  color: #ce0c0c;
  font-size: 14px;
  font-weight: 500;
  background-color: #fff;
  opacity: 1;
  animation: fadein 200ms ease-in-out;

  @keyframes fadein {
    from{
      opacity: 0;
    }
    to{
      opacity: 1;
    }
  }
  .alertIcon{
    width: 24px;
    height: 24px;
    padding: 16px;
    border-radius: 100%;
    color: #fff !important;
    font-size: 20px;
    vertical-align: 0;
    background-color: #ce0c0c;
  }
}
.contentsNone{
  padding: 8px 0;
  border-top: 1px solid #ccc;
  border-bottom: 1px solid #ccc;
  font-size: 14px;
  text-align: center;

  i{
    width: 38px;
    height: 38px;
    border-radius: 100%;
    color: #fff !important;
    font-size: 24px;
    background-color: #ce0c0c;
  }
  .contentsTitle{
    margin-bottom: 0px;
    color: #ce0c0c;
    font-size: 24px;
    font-weight: 700;
  }
}
.customPage{
  width: 100%;
  height: 100%;
  padding-top: 40px;
  background-color: #FFB5CC;

  .customPageTitle{
    color: #fff;
    font-size: 20px;
    font-weight: 500;
    text-align: center;
    letter-spacing: -0.5px;

    &.pink{
      color: #ffb5cc;
      background-color: transparent !important;
    }
  }
  .customPageSubtitle{
    font-size: 14px;
  }
  .customPageContent{
    width: 100%;
    height: calc(100% - 10px);
    padding: 60px 20px !important;
    margin-top: 20px;
    border-radius: 40px 40px 0 0;
    background-color: #fff;

    .v-input{
      margin-bottom: 16px;

      &.v-input--is-focused{
        .v-input__icon{
          .v-icon{
            color: #fff !important;
            background-color: #FFB5CC;
          }
        }
        .v-input__icon--clear{
          .v-icon{
            color: #FFB5CC !important;
            background-color: transparent;
          }
        }
      }

      .v-input__icon{
        width: 48px;
    
        .v-icon{
          width: 48px;
          height: 48px;
          border-radius: 10px;
          color: #fff;
          background-color: #c4c4c4;
        }
      }
      .v-input__icon--clear{
        width: 24px;

        .v-icon{
          width: auto;
          height: auto;
          color: #555;
          background-color: transparent;
        }
      }
    }
    .customPageCheckbox{
      display: flex;
      justify-content: flex-end;

      .v-input--selection-controls{
        margin-top: 0;
        margin-bottom: 8px;
      }
    }
  }
}
.profile-image{
  background-color: #fff;
  box-shadow: 0 2px 4px rgba(0,0,0,.25);
}
</style>